<template>
<div>
    <div class="logo">
        <img v-if="$i18n.locale == 'se'" src="img/kunniakierros-logo-se.png" />
        <img v-else src="img/kunniakierros-logo-fi.png" />
    </div>

    <h1>{{ store.page.title }}</h1>
    
    <p v-for="(paragraph, i) in description.split('\n')" class="about" :key="i">
        {{ paragraph }}<br>
    </p>

     <router-link to="/login">
        <button class="button button-green">
            {{ $t("startView.login") }}
        </button>
    </router-link>
</div>
</template>

<script lang="ts">
import { store } from "store";
import axios from "axios";
import { defineComponent } from "vue";

interface KKInfo {
    title: string;
    description: string;
}

export default defineComponent({
    async mounted() {
        await this.setTitle();
    },
    data() {
        return {
            store: store,
            description: ""
        };
    },
    methods: {
       async setTitle() {
            let aboutKK: KKInfo = (await axios.get<KKInfo>("applicationsettings/description", { params: { locale: this.$i18n.locale }})).data;
            store.page.showTopNav = true;
            this.description = aboutKK.description;
            store.page.title = aboutKK.title;
        }
    }
})

</script>